import {getAccessToken} from '@lib/store';
import {useImagesWithBaseUrl} from './useImagesWithBaseUrl';
import {useSelector} from 'react-redux';

export type UserImageHash = {
  userId: string;
  imageHash: string;
};

/**
 * @param imageHash string
 * @returns URL to profile picture as string
 */
export const useUserProfilePicsWithBaseUrl = (apiBaseURL: string, userImageHashes: UserImageHash[], size = 64) => {
  const token = useSelector(getAccessToken) || '';

  const keyedEndpoints = userImageHashes?.reduce(
    (acc, {userId, imageHash}) =>
      imageHash
        ? {
            ...acc,
            [userId]: `shifts/profilepictures/${imageHash}?size=${size}`,
          }
        : acc,
    {},
  );

  const userProfilePics = useImagesWithBaseUrl(apiBaseURL, token, keyedEndpoints, '2.0');

  return userProfilePics;
};
